export const taxRate = 0.25;
export const taxRateString = "25%";
export const getValueWithTax = (value) => value * (1 + taxRate);
export const getTaxFromValue = (value) => value * taxRate;